import { render, staticRenderFns } from "./ConveniosView.vue?vue&type=template&id=2b951dc8&scoped=true&"
import script from "./ConveniosView.vue?vue&type=script&lang=ts&"
export * from "./ConveniosView.vue?vue&type=script&lang=ts&"
import style0 from "./ConveniosView.vue?vue&type=style&index=0&id=2b951dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b951dc8",
  null
  
)

export default component.exports